import { render, staticRenderFns } from "./InputWrapper.vue?vue&type=template&id=dfbb1282&"
import script from "./InputWrapper.vue?vue&type=script&lang=ts&"
export * from "./InputWrapper.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports